import {i18n} from '@yourcoach/i18n';

import type {CourseApiModel} from '../../../api/course';
import type {CoreCoachCoursesDeleteParams} from '../../../api/types/core/methods';
import type {AsyncStrategy, BaseConfig} from '../utils';

import {logger} from '../../..//utils/logger';
import {courseStore} from '../../../api/course';
import {isCourseDeletable} from '../../../utils/entity/course/isCourseDeletable';
import {isMeCoachForEntity} from '../../../utils/entity/isMeCoachForEntity';
import {AppError} from '../../../utils/errors/app';
import {COMMAND} from '../utils';
import {deleteCourseConfirmAlert} from './deleteCourseConfirmAlert';

export {courseDelete};

type Config = BaseConfig<Omit<CoreCoachCoursesDeleteParams, '_id'>> & {
  entity: CourseApiModel;
};

const strategy: AsyncStrategy<Config> = async (roles, config) => {
  if (isMeCoachForEntity(config.entity)) {
    return roles.coach(config);
  } else {
    return roles.client(config);
  }
};

async function courseDelete(config: Config) {
  return strategy({client: asClient, coach: asCoach}, config);
}

courseDelete.asClient = asClient;
courseDelete.asCoach = asCoach;

async function asClient(_config: Config) {
  throw new AppError('not_allowed');
}

async function asCoach({entity, params}: Config) {
  if (!isCourseDeletable(entity)) {
    throw new Error(i18n.t('shared:cant_delete_course'));
  }

  try {
    if (!(await deleteCourseConfirmAlert())) {
      return COMMAND.CANCEL;
    }

    await courseStore.delete(entity, params);
    logger.event('group_delete_success');
  } catch (error) {
    logger.error(error);
    logger.event('group_delete_fail', {reason: error.message});

    throw error;
  }
}
